import { useRef, useState } from "react";
import { toast } from "sonner";
import { Download, FileUp, X } from "lucide-react";
import { api, formatError } from "@/lib/api";

export const downloadCertificate = async (id, filename = "certificate.pdf") => {
  try {
    const res = await api.get(`/enrolments/${id}/certificate`, { responseType: "blob" });
    const url = URL.createObjectURL(res.data);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    a.click();
    setTimeout(() => URL.revokeObjectURL(url), 1000);
  } catch (e) { toast.error("Couldn't download the certificate. Please try again."); }
};

export const CertificateCell = ({ e, reload }) => {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);
  const upload = async (file) => {
    if (!file) return;
    if (file.type !== "application/pdf") { toast.error("Please choose a PDF file"); return; }
    setBusy(true);
    const fd = new FormData();
    fd.append("file", file);
    try { await api.post(`/admin/enrolments/${e.id}/certificate`, fd); toast.success("Certificate uploaded"); reload(); }
    catch (err) { toast.error(formatError(err)); } finally { setBusy(false); if (ref.current) ref.current.value = ""; }
  };
  const remove = async () => {
    try { await api.delete(`/admin/enrolments/${e.id}/certificate`); toast.success("Certificate removed"); reload(); } catch (err) { toast.error(formatError(err)); }
  };

  if (e.status !== "completed") return <span className="text-xs text-ink/50">—</span>;
  return (
    <div className="flex flex-col items-start gap-1">
      {e.certificate && (
        <span className="flex items-center gap-1">
          <button data-testid={`admin-cert-view-${e.id}`} onClick={() => downloadCertificate(e.id, e.certificate.filename)} className="flex items-center gap-1 text-xs font-semibold text-gum underline-offset-2 hover:underline"><Download className="h-3.5 w-3.5" />{e.certificate.filename}</button>
          <button data-testid={`admin-cert-remove-${e.id}`} onClick={remove} aria-label="Remove certificate" className="rounded-full p-1 text-ink/50 hover:text-ochre"><X className="h-3.5 w-3.5" /></button>
        </span>
      )}
      <input ref={ref} type="file" accept="application/pdf" className="hidden" data-testid={`admin-cert-input-${e.id}`} onChange={(ev) => upload(ev.target.files?.[0])} />
      <button data-testid={`admin-cert-upload-${e.id}`} disabled={busy} onClick={() => ref.current?.click()} className="flex items-center gap-1 rounded-full border border-ink/20 px-3 py-1 text-xs hover:border-ochre disabled:opacity-60">
        <FileUp className="h-3.5 w-3.5" /> {busy ? "Uploading…" : e.certificate ? "Replace PDF" : "Upload PDF"}
      </button>
    </div>
  );
};
